<template>
  <div class="mianDiv">
    <img :src="srcUrl" alt="" class="imgMobile" />
    <div class="textMobile">{{ err }}~</div>
  </div>
</template>
<script>
import defaultUrl from "./img/empty_nopower.png";
export default {
  props: {
    err: {
      type: String,
      default: "无访问权限"
    },
    srcUrl: {
      type: String,
      default: defaultUrl
    }
  },
  data() {
    return {};
  },
  methods: {},
  created() {}
};
</script>
<style lang="less" scoped>
.mianDiv {
  // height: 100%;
  // width: 100%;
  // overflow: auto;
  // background-color: #fff;
  text-align: center;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // flex-flow: column;
  & > .imgMobile {
    width: 300px;
  }
  & > .textMobile {
    color: #999;
    font-size: 17px;
  }
}
</style>
